export default "__VITE_ASSET__CE3lX838__"